export default __webpack_public_path__ + "static/David-Miskimens-75c8c427b7b0d4edeb5bbd69f03540b3.jpg";